import React from 'react';
import Link from 'next/link';

const LETTERS = ['#', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')];


// Horizontal A–Z index. Available letters link to their per-letter page;
// letters with no terms are rendered greyed-out and non-clickable.
export default function AlphabetIndex({ availableLetters = [], activeLetter = null }) {
  const available = new Set(
    (availableLetters || []).map((l) => String(l).toUpperCase())
  );
  const active = activeLetter ? String(activeLetter).toUpperCase() : '#';

  return (
    <section className="alphabet-section-glo">
      <div className="alphabet-index-glo">
        {LETTERS.map((letter) => {
          const isActive = active === letter;

          if (letter === '#') {
            return (
              <Link
                key={letter}
                href="/glossary"
                className={`alpha-letter-glo${isActive ? ' active' : ''}`}
              >
                {letter}
              </Link>
            );
          }

          const isAvailable = available.has(letter);

          if (!isAvailable) {
            return (
              <span key={letter} className="alpha-letter-glo disabled" aria-disabled="true">
                {letter}
              </span>
            );
          }

          return (
            <Link
              key={letter}
              href={`/glossary/letter/${letter.toLowerCase()}`}
              className={`alpha-letter-glo${isActive ? ' active' : ''}`}
            >
              {letter}
            </Link>
          );
        })}
      </div>
    </section>
  );
}
